/**
 * Simple scrollbar styling constants for web platform
 */

import { Platform } from "react-native";

// Basic scrollbar styles for web
export const webScrollbarStyles =
  Platform.OS === "web"
    ? {
        scrollbarWidth: "thin" as const,
        scrollbarColor: "#C0C0C0 transparent"
      }
    : {};
